"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("../../components/Icon/components");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var DECIMAL_SVG_GROUP = {
  0: function _(_ref) {
    var color = _ref.color;
    return /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(-32.000000, -26.000000)",
      stroke: color
    }, /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(34.000000, 28.000000)"
    }, /*#__PURE__*/_react.default.createElement("polygon", {
      points: "8 13.090105 3.05616402 16 4.16016823 10.1566243 0 6.1116639 5.6265662 5.4099871 8 0 10.3734338 5.4099871 16 6.1116639 11.8398318 10.1566243 12.943836 16"
    })));
  },
  1: function _(_ref2) {
    var color = _ref2.color;
    return /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(-54.000000, -26.000000)"
    }, /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(56.000000, 28.000000)"
    }, /*#__PURE__*/_react.default.createElement("polygon", {
      stroke: color,
      "stroke-linecap": "round",
      points: "8 13.090105 3.05616402 16 4.16016823 10.1566243 0 6.1116639 5.6265662 5.4099871 8 0 10.3734338 5.4099871 16 6.1116639 11.8398318 10.1566243 12.943836 16"
    }), /*#__PURE__*/_react.default.createElement("polygon", {
      fill: color,
      points: "3 9 0 6.1116639 3 6"
    })));
  },
  2: function _(_ref3) {
    var color = _ref3.color;
    return /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(-76.000000, -26.000000)"
    }, /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(78.000000, 28.000000)"
    }, /*#__PURE__*/_react.default.createElement("polygon", {
      stroke: color,
      "stroke-linecap": "round",
      points: "8 13.090105 3.05616402 16 4.16016823 10.1566243 0 6.1116639 5.6265662 5.4099871 8 0 10.3734338 5.4099871 16 6.1116639 11.8398318 10.1566243 12.943836 16"
    }), /*#__PURE__*/_react.default.createElement("polygon", {
      fill: color,
      points: "4 10 0 6.1116639 4 6"
    })));
  },
  3: function _(_ref4) {
    var color = _ref4.color;
    return /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(-98.000000, -26.000000)"
    }, /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(100.000000, 28.000000)"
    }, /*#__PURE__*/_react.default.createElement("polygon", {
      stroke: color,
      "stroke-linecap": "round",
      points: "8 13.090105 3.05616402 16 4.16016823 10.1566243 0 6.1116639 5.6265662 5.4099871 8 0 10.3734338 5.4099871 16 6.1116639 11.8398318 10.1566243 12.943836 16"
    }), /*#__PURE__*/_react.default.createElement("polygon", {
      fill: color,
      points: "6 14 3 16 4 10 0 6.1116639 6 5"
    })));
  },
  4: function _(_ref5) {
    var color = _ref5.color;
    return /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(-120.000000, -26.000000)"
    }, /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(122.000000, 28.000000)"
    }, /*#__PURE__*/_react.default.createElement("polygon", {
      stroke: color,
      "stroke-linecap": "round",
      points: "8 13.090105 3.05616402 16 4.16016823 10.1566243 0 6.1116639 5.6265662 5.4099871 8 0 10.3734338 5.4099871 16 6.1116639 11.8398318 10.1566243 12.943836 16"
    }), /*#__PURE__*/_react.default.createElement("polygon", {
      fill: color,
      points: "7 14 3 16 4 10 0 6.1116639 6 5 7 3"
    })));
  },
  5: function _(_ref6) {
    var color = _ref6.color;
    return /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(-142.000000, -26.000000)"
    }, /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(144.000000, 28.000000)"
    }, /*#__PURE__*/_react.default.createElement("polygon", {
      stroke: color,
      "stroke-linecap": "round",
      points: "8 13.090105 3.05616402 16 4.16016823 10.1566243 0 6.1116639 5.6265662 5.4099871 8 0 10.3734338 5.4099871 16 6.1116639 11.8398318 10.1566243 12.943836 16"
    }), /*#__PURE__*/_react.default.createElement("polygon", {
      fill: color,
      points: "8 13.090105 3.05616402 16 4.16016823 10.1566243 0 6.1116639 5.6265662 5.4099871 8 0"
    })));
  },
  6: function _(_ref7) {
    var color = _ref7.color;
    return /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(-164.000000, -26.000000)"
    }, /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(166.000000, 28.000000)"
    }, /*#__PURE__*/_react.default.createElement("polygon", {
      stroke: color,
      "stroke-linecap": "round",
      points: "8 13.090105 3.05616402 16 4.16016823 10.1566243 0 6.1116639 5.6265662 5.4099871 8 0 10.3734338 5.4099871 16 6.1116639 11.8398318 10.1566243 12.943836 16"
    }), /*#__PURE__*/_react.default.createElement("polygon", {
      fill: color,
      points: "8 13.090105 3.05616402 16 4.16016823 10.1566243 0 6.1116639 5.6265662 5.4099871 8 0 9 3 9 14"
    })));
  },
  7: function _(_ref8) {
    var color = _ref8.color;
    return /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(-186.000000, -26.000000)"
    }, /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(188.000000, 28.000000)"
    }, /*#__PURE__*/_react.default.createElement("polygon", {
      stroke: color,
      "stroke-linecap": "round",
      points: "8 13.090105 3.05616402 16 4.16016823 10.1566243 0 6.1116639 5.6265662 5.4099871 8 0 10.3734338 5.4099871 16 6.1116639 11.8398318 10.1566243 12.943836 16"
    }), /*#__PURE__*/_react.default.createElement("polygon", {
      fill: color,
      points: "8 13.090105 3.05616402 16 4.16016823 10.1566243 0 6.1116639 5.6265662 5.4099871 8 0 10 5 10 14"
    })));
  },
  8: function _(_ref9) {
    var color = _ref9.color;
    return /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(-208.000000, -26.000000)"
    }, /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(210.000000, 28.000000)"
    }, /*#__PURE__*/_react.default.createElement("polygon", {
      stroke: color,
      "stroke-linecap": "round",
      points: "8 13.090105 3.05616402 16 4.16016823 10.1566243 0 6.1116639 5.6265662 5.4099871 8 0 10.3734338 5.4099871 16 6.1116639 11.8398318 10.1566243 12.943836 16"
    }), /*#__PURE__*/_react.default.createElement("polygon", {
      fill: color,
      points: "8 13.090105 3.05616402 16 4.16016823 10.1566243 0 6.1116639 5.6265662 5.4099871 8 0 10 5 12 6 12 10 13 16"
    })));
  },
  9: function _(_ref10) {
    var color = _ref10.color;
    return /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(-230.000000, -26.000000)"
    }, /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(232.000000, 28.000000)"
    }, /*#__PURE__*/_react.default.createElement("polygon", {
      stroke: color,
      "stroke-linecap": "round",
      points: "8 13.090105 3.05616402 16 4.16016823 10.1566243 0 6.1116639 5.6265662 5.4099871 8 0 10.3734338 5.4099871 16 6.1116639 11.8398318 10.1566243 12.943836 16"
    }), /*#__PURE__*/_react.default.createElement("polygon", {
      fill: color,
      points: "8 13.090105 3.05616402 16 4.16016823 10.1566243 0 6.1116639 5.6265662 5.4099871 8 0 11 6 13 6 13 9 12 10 13 16"
    })));
  },
  10: function _(_ref11) {
    var color = _ref11.color;
    return /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(-252.000000, -26.000000)",
      fill: color,
      stroke: color
    }, /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(254.000000, 28.000000)"
    }, /*#__PURE__*/_react.default.createElement("polygon", {
      points: "8 13.090105 3.05616402 16 4.16016823 10.1566243 0 6.1116639 5.6265662 5.4099871 8 0 10.3734338 5.4099871 16 6.1116639 11.8398318 10.1566243 12.943836 16"
    })));
  }
};
var StarIcon = function StarIcon(_ref12) {
  var color = _ref12.color,
    _ref12$decimals = _ref12.decimals,
    decimals = _ref12$decimals === void 0 ? 0 : _ref12$decimals,
    _ref12$size = _ref12.size,
    size = _ref12$size === void 0 ? 15 : _ref12$size;
  var DecimalSvgGroup = DECIMAL_SVG_GROUP[decimals] || DECIMAL_SVG_GROUP[0];
  return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, {
    size: size,
    viewBox: "0 0 20 19",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement(DecimalSvgGroup, {
    color: color
  })));
};
var _default = StarIcon;
exports.default = _default;